import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Button, makeStyles } from '@material-ui/core';
import * as XLSX from 'xlsx';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles(({
  containerForm: {
    display: 'flex',
    flexDirection: 'column'
  },
  input: {
    display: 'none'
  },
  labelInput: {
    cursor: 'pointer',
    width: '100%',
    padding: '16px',
    marginTop: '16px',
    textAlign: 'center',
    borderColor: '#019592',
    borderStyle: 'dashed',
    borderWidth: '2px',
    marginBottom: '8px'
  },
  containerButton: {
    display: 'flex',
    justifyContent: 'space-evenly',
    alignItems: 'center',
    marginTop: '16px'
  }
}));

const downloadXLSX = (variable = [], notificationType) => {
  const filteredVariables = variable.filter(value => value !== 'validate' && value !== 'url');

  const worksheet = XLSX.utils.json_to_sheet([]);
  const workbook = XLSX.utils.book_new();

  XLSX.utils.book_append_sheet(workbook, worksheet, 'Dates');
  if (notificationType === 'email') {
    XLSX.utils.sheet_add_aoa(worksheet, [['email'].concat(filteredVariables)], { origin: 'A1' });
  } else if (notificationType === 'sms') {
    XLSX.utils.sheet_add_aoa(worksheet, [['phoneNumber'].concat(filteredVariables)], { origin: 'A1' });
  }

  worksheet['!cols'] = [ { wch: 100 } ];
  XLSX.writeFile(workbook, 'template.xlsx');
};

const FormFileXlsx = ({ variable, onChange, setExcelData, notificationType }) => {
  const { t } = useTranslation();
  const [excelFile, setExcelFile] = useState(null);
  const [typeError, setTypeError] = useState(null);
  const classes = useStyles();

  const handleFile = (e) => {
    const imageName = document.getElementById('nameFileSlected');
    let fileTypes = ['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'text/csv'];
    let selectedFile = e.target.files[0];
    if (selectedFile) {
      if (selectedFile && fileTypes.includes(selectedFile.type)) {
        const inputImage = document.querySelector('input[type=file]').files[0];
        imageName.innerText = inputImage.name;
        setTypeError(null);
        let reader = new FileReader();
        reader.readAsArrayBuffer(selectedFile);
        reader.onload = (e) => {
          setExcelFile(e.target.result);
        };
      } else {
        setTypeError('Please select only excel file types');
        setExcelFile(null);
      }
    } else {
      console.log('Please select your file');
    }
  };
  useEffect(() => {
    if (excelFile) {
      const workbook = XLSX.read(excelFile, { type: 'buffer' });
      const worksheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[worksheetName];
      const data = XLSX.utils.sheet_to_json(worksheet);
      setExcelData(data);
      onChange((prv) => ({ ...prv, step2: { workbook, excelData: data } }));
    }
  }, [excelFile]);

  const handleFileSubmit = (e) => {
    e.preventDefault();
  };

  return (
    <form onSubmit={handleFileSubmit} className={classes.containerForm}>
      <label htmlFor='file' className={classes.labelInput}>
        {t('wizardBulkNotification:selecteFile')}
        <input id='file' className={classes.input} type='file' required onChange={handleFile} />
        <br />
        <strong id='nameFileSlected' />
      </label>
      <div className={classes.containerButton}>
        <Button color='primary' variant='contained' onClick={() => downloadXLSX(variable, notificationType)}>
          {t('wizardBulkNotification:downloadXlsx')}
        </Button>
      </div>
      {typeError && (
        <div role='alert'>{typeError}</div>
      )}
    </form>
  );
};

FormFileXlsx.propTypes = {
  onChange: PropTypes.func.isRequired,
  variable: PropTypes.array,
  setExcelData: PropTypes.func.isRequired
};

export default FormFileXlsx;
